import axios from 'axios';
import React, { useEffect, useState } from 'react';

const Logo = () => {
  const style = {
    width: '20%',
    marginLeft: `2%`,
    height: '70%'
  };

  const[logo, setLogo] = useState('');

  const getLogo = () => {
    axios
      .get('api/logo/get')
      .then((response) => {
        setLogo(response.data);
      })
      .catch(function (error){
        console.log(error);
      });
  };

  useEffect(() => {
    getLogo();
  }, []);

  return (
    <div className="headerLogo">
      <img style={style} src={`data:image/jpg;base64, ${logo}`} alt="ci" />
    </div>
  );
};

export default Logo;
